<template>
  <v-app
    class="justify-center"
    justify="center"
    fluid
    align="center"
  >
    <div>
      <v-img
        style="max-width: 1200px"
        src="../../assets/vw_logo.png"
      >
      </v-img>

      <template
        v-if="signupRowkey === ''"
      >
        <v-form
          ref="form"
          v-model="isFormValid"

          style="max-width: 1200px"
          justify="left"
          align="left"
        >
          <v-container
            id="schedule-index"
            fluid
            tag="section"
          >
            <h2>
              Application to Upgrade Service
            </h2>
            <v-row justify="center">
              <v-col
                cols="12"
              >
                <v-row>
                  <!--              Location Detail Section-->
                  <v-col
                    cols="12"
                  >
                    <v-card class="px-3 py-2 my-n1">
                      <v-card-title>
                        <h3>Service Location</h3>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-row>
                        <!--                        Google Maps-->
                        <v-col
                          cols="12"
                        >
                          <h2>
                            Please use the textbox below to search for your address
                          </h2>
                          <vue-google-autocomplete
                            id="acmap"
                            style="width: 90%; border-style: solid; border-width: 2px"
                            classname="form-control pa-3 ma-3"
                            placeholder="Start typing"
                            @placechanged="getAddressData"
                          >
                          </vue-google-autocomplete>
                        </v-col>
                        <v-col
                          v-show="!locationServiceable"
                        >
                          <v-alert
                            prominent
                            type="error"
                          >
                            <v-row align="center">
                              <v-col class="grow">
                                Unfortunately it does not appear we can provide service to this location
                              </v-col>
                            </v-row>
                          </v-alert>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <GmapMap
                            class="mt-7"
                            sm="12"
                            :center="apptCoords"
                            :zoom="16"
                            map-type-id="terrain"
                            :style="mapStyleMd"
                          >
                            <GmapMarker
                              :position="apptCoords"
                            />
                          </GmapMap>
                        </v-col>
                      </v-row>
                      <v-row
                        v-show="acAddressComponents.street_number && acAddressComponents.street_number.length > 0"
                      >
                        <!--              Service Address Details-->
                        <v-col cols="12">
                          <v-text-field
                            v-model="formValues.locationService.addr1"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Street Address
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="formValues.locationService.city"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                City
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="formValues.locationService.state"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                State
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-text-field
                            v-model="formValues.locationService.zip"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Zip code
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>

                        <!--                Location Type-->
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.serviceType"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Location Type:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsLocationTypes"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option">
                                  {{ opt.text }}
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <!--              Floor Details single/multi -->
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.locationDesc"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                How many floors is the home or building?
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsLocationDesc"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option">
                                  {{ opt.text }}
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <!--              Roof Material-->
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.roofMaterial"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Roof Material:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsRoofMaterial"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option">
                                  {{ opt.text }}
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <!--              Square Footage-->
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.squareFootage"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Approximate size of building or home?
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsSquareFootage"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option">
                                  {{ opt.text }}
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <!--              Ownership Status-->
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.ownershipStatus"
                            :rules="[rules.required]"
                            label="Ownership:"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Ownership:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsOwnershipStatus"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option">
                                  {{ opt.text }}
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <!--              Permission to modify status-->
                        <v-col
                          cols="12"
                        >
                          <v-checkbox
                            v-model="formValues.canModify"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Do you have permission to modify the structure?
                              </div>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <!--              Confirm Mount Equipment-->
                        <v-col
                          cols="12"
                        >
                          <v-checkbox
                            v-model="formValues.confirmMountEquipment"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Do you understand we will be mounting equipment to the structure and/or roof?
                              </div>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <!--              Account Holder Details-->
                  <v-col
                    v-show="acAddressComponents.street_number && acAddressComponents.street_number.length > 0"
                    cols="12"
                  >
                    <v-card class="px-3 py-2 my-n1">
                      <v-card-title>
                        <h3>Account Owner</h3>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.accountHolder.first_name"
                            label="First Name"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                First Name
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.accountHolder.last_name"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Last Name
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="formValues.accountHolder.mobile_phone"
                                counter
                              >
                                <template v-slot:label>
                                  <div class="lbl-header">
                                    Mobile Phone
                                  </div>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              md="3"
                            >
                              <v-text-field
                                v-model="formValues.accountHolder.mobile_phone_code"
                                :success="formValues.accountHolder.mobile_phone_verified"
                                :error="!formValues.accountHolder.mobile_phone_verified"
                                placeholder="SMS Code"
                                @input="onMobileCodeChange"
                              >
                                <template v-slot:label>
                                  <div class="lbl-header">
                                    SMS Code
                                  </div>
                                </template>
                                <template v-slot:append>
                                  <v-icon
                                    v-if="formValues.accountHolder.mobile_phone_verified"
                                    color="success"
                                  >
                                    mdi-check
                                  </v-icon>
                                  <v-icon
                                    v-else
                                    color="warning"
                                  >
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              md="3"
                            >
                              <v-chip
                                v-if="formValues.accountHolder.mobile_phone_verified"
                                color="success"
                              >
                                Verified
                              </v-chip>
                              <v-btn
                                v-else
                                color="info"
                                :disabled="formValues.accountHolder.mobile_phone_verified || formValues.accountHolder.mobile_phone.length !== 10"
                                @click="doRetrieveMobileCode"
                              >
                                Send SMS Code
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.accountHolder.alt_phone"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Alternate Phone
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <!--                    Account Holder Email-->
                        <v-col
                          cols="12"
                        >
                          <v-row>
                            <v-col
                              cols="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="formValues.accountHolder.email"
                                :rules="[rules.required, rules.email]"
                              >
                                <template v-slot:label>
                                  <div class="lbl-header">
                                    Email
                                  </div>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              md="3"
                            >
                              <v-text-field
                                id="not-what-you-want"
                                v-model="formValues.accountHolder.email_code"
                                :success="formValues.accountHolder.email_verified"
                                :error="!formValues.accountHolder.email_verified"
                                placeholder="Code"
                                value=""
                                @input="onEmailCodeChange"
                              >
                                <template v-slot:label>
                                  <div class="lbl-header">
                                    Code
                                  </div>
                                </template>
                                <template v-slot:append>
                                  <v-icon
                                    v-if="formValues.accountHolder.email_verified"
                                    color="success"
                                  >
                                    mdi-check
                                  </v-icon>
                                  <v-icon
                                    v-else
                                    color="warning"
                                  >
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="6"
                              md="3"
                            >
                              <v-chip
                                v-if="formValues.accountHolder.email_verified"
                                color="success"
                              >
                                Verified
                              </v-chip>
                              <v-btn
                                v-else
                                color="info"
                                :disabled="formValues.accountHolder.email_verified"
                                @click="doRetrieveEmailCode"
                              >
                                Send Email Code
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <!--              Billing Details-->
                  <v-col
                    v-show="acAddressComponents.street_number && acAddressComponents.street_number.length > 0"
                    cols="12"
                  >
                    <v-card class="px-3 py-2 my-n1">
                      <v-card-title>
                        <h3>Billing</h3>
                        <v-btn
                          small
                          color="info"
                          class="ml-4 float-left"
                          @click="doCopyAccountHolder"
                        >
                          Copy Account Holder
                        </v-btn>
                      </v-card-title>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.billingHolder.first_name"
                            label="First Name"
                            :rules="[rules.required]"
                            required
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                First Name
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.billingHolder.last_name"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Last Name
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.billingHolder.mobile_phone"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Mobile Phone
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="formValues.billingHolder.alt_phone"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Alternate Phone
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="formValues.billingHolder.email"
                            :rules="[rules.required, rules.email]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Email
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-card
                            class="mx-3 px-4"
                          >
                            <v-card-title>
                              <h5>Billing Address</h5>
                              <v-btn
                                small
                                color="info"
                                class="ml-3 float-left"
                                @click="doCopyServiceAddress"
                              >
                                Copy Service Address
                              </v-btn>
                            </v-card-title>
                            <v-row>
                              <v-col
                                cols="12"
                              >
                                <v-text-field
                                  v-model="formValues.locationBilling.addr1"
                                  :rules="[rules.required]"
                                  required
                                >
                                  <template v-slot:label>
                                    <div class="lbl-header">
                                      Street Address
                                    </div>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                              >
                                <v-text-field
                                  v-model="formValues.locationBilling.city"
                                  :rules="[rules.required]"
                                  required
                                >
                                  <template v-slot:label>
                                    <div class="lbl-header">
                                      City
                                    </div>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                              >
                                <v-text-field
                                  v-model="formValues.locationBilling.state"
                                  :rules="[rules.required]"
                                  required
                                >
                                  <template v-slot:label>
                                    <div class="lbl-header">
                                      State
                                    </div>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                              >
                                <v-text-field
                                  v-model="formValues.locationBilling.zip"
                                  :rules="[rules.required]"
                                  required
                                >
                                  <template v-slot:label>
                                    <div class="lbl-header">
                                      Zip code
                                    </div>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.servicePlan"
                            :rules="[rules.required]"
                            label="Service Plan:"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Service Plan:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsServicePlans"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option align-bottom">
                                  <span style="font-weight: bold">{{ opt.text }} (${{ opt.price }}/mo)</span>
                                  <p>{{ opt.description }}</p>
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.installType"
                            :rules="[rules.required]"
                            label="Service Plan:"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Installation Type:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsInstallType"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option align-bottom">
                                  <span style="font-weight: bold">{{ opt.text }} (${{ opt.price }} Fee)</span>
                                  <p>{{ opt.description }}</p>
                                </div>
                              </template>
                              <template v-slot:append>
                                <div class="lbl-option">
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.paymentFrequency"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Payment Frequency:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsPaymentFrequency"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option align-bottom">
                                  <span style="font-weight: bold">{{ opt.text }}</span>
                                  <p>{{ opt.description }}</p>
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-radio-group
                            v-model="formValues.paymentMethod"
                            :rules="[rules.required]"
                          >
                            <template v-slot:label>
                              <div class="lbl-header">
                                Payment Method:
                              </div>
                            </template>
                            <v-radio
                              v-for="opt in optionsPaymentMethod"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              <template v-slot:label>
                                <div class="lbl-option align-bottom">
                                  <span style="font-weight: bold">{{ opt.text }}</span>
                                  <p>{{ opt.description }}</p>
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <!--              Add-ons Details-->
                  <v-col
                    v-show="acAddressComponents.street_number && acAddressComponents.street_number.length > 0"
                    cols="12"
                  >
                    <v-card class="px-3 py-2 my-n1">
                      <v-card-title>
                        <h3>Add-ons</h3>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-row>
                        <v-col
                          cols="12"
                        >
                          <v-card>
                            <v-card-title>
                              <h5>No Worries</h5>
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <div
                              class="mx-3 px-3 py-3"
                              style="text-align: left"
                            >
                              Velociter's service requires an indoor modem/router device. <span style="font-weight: bold">No Worries</span> provides this for a low monthly rental.
                              Also included are these features:
                              <ul>
                                <li>
                                  No hassle exchange warranty for your router
                                </li>
                                <li>
                                  Accidental damage coverage for your router ($25 deductible)
                                </li>
                                <li>
                                  Accidental damage coverage for your outdoor receiver ($75 deductible)
                                </li>
                                <li>
                                  Weekly firewall updates for your router
                                </li>
                              </ul>
                              Opting out of <span style="font-weight: bold">No Worries</span> means you will be responsible for the full replacement cost of the router ($169) and the outdoor receiver ($589) should they become damaged.
                              <v-col
                                cols="12"
                                md="6"
                              >
                                <v-radio-group
                                  v-model="formValues.enrollNoWorries"
                                  :rules="[rules.required]"
                                >
                                  <template v-slot:label>
                                    <div class="lbl-header">
                                      Enroll in <span style="font-weight: bold">No Worries</span> for $6.99 per month?
                                    </div>
                                  </template>
                                  <v-radio
                                    v-for="opt in optionsEnrollNoWorries"
                                    :key="opt.value"
                                    :value="opt.value"
                                  >
                                    <template v-slot:label>
                                      <div class="lbl-option">
                                        {{ opt.text }}
                                      </div>
                                    </template>
                                  </v-radio>
                                </v-radio-group>
                              </v-col>
                            </div>
                          </v-card>
                          <v-card>
                            <v-card-title>
                              <h5>Wifi Upgrade</h5>
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <div class="mx-3 px-3">
                              Our WiFi experts will take the guess work out of full home coverage. Velociter offers a WiFi
                              coverage upgrade that begins with a professional analyzing your location for WiFi weak and
                              dead zones. Next we add a WiFi access point in a strategic location and connect it to your
                              primary WiFi router with a network cable for the best performance and reliability.
                              Finally we take care of all the device programming so you have confidence the job is done right.
                            </div>
                            <div class="mx-3 px-3 py-3">
                              Large, multi-story locations require more than one WiFi source to provide full reliable
                              coverage to all parts of the location. Aftermarket "range extenders" rely on weak wireless
                              signals or the electrical wires to rebroadcast WiFi. These range extenders are costly and
                              often have disappointing performance.
                            </div>
                            <div class="mx-3 px-3 py-3">
                              This service requires enrollment in <span style="font-weight: bold">No Worries</span> and
                              is offered at a discounted <b>one-time fee of $139</b> and a monthly rent of $3.95 for the second WiFi device.
                            </div>
                            <v-checkbox
                              v-model="formValues.enrollWifiUpgrade"
                              class="ml-4"
                              :disabled="formValues.enrollNoWorries === -1 || formValues.enrollNoWorries === 0"
                            >
                              <template v-slot:label>
                                <div class="lbl-header">
                                  Would you like to add Wifi Coverage upgrade? $3.95 per month
                                </div>
                              </template>
                            </v-checkbox>
                            <div
                              v-if="formValues.squareFootage > 1599"
                              class="mx-3 px-5 my-n5"
                            >
                              <span style="font-size: .8em; color: firebrick;">We recommend this add-on based on the area covered.</span>
                            </div>
                          </v-card>
                          <v-card>
                            <v-card-title>
                              <h5>Network Jacks</h5>
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <div class="mx-3 px-3">
                              For best performance, we recommend that Smart TVs, game counsels, and gaming systems
                              are plugged into the router by a cable. These devices can be connected to WiFi but their
                              speed will be slower and have a higher latency vs. connected by a network cable.
                            </div>
                            <v-checkbox
                              v-model="formValues.addNetworkJacks"
                              class="ml-4"
                            >
                              <template v-slot:label>
                                <div class="lbl-header">
                                  Would you like a technician to install network jacks?
                                </div>
                              </template>
                            </v-checkbox>
                            <div
                              v-if="formValues.addNetworkJacks"
                              class="mx-3 px-5 my-n5"
                            >
                              <v-radio-group
                                v-model="formValues.addNetworkJacksQuantity"
                              >
                                <template v-slot:label>
                                  <div class="lbl-header">
                                    Quantity:
                                  </div>
                                </template>
                                <v-radio
                                  v-for="opt in optionsNetworkJacks"
                                  :key="opt.value"
                                  :value="opt.value"
                                >
                                  <template v-slot:label>
                                    <div class="lbl-option">
                                      {{ opt.text }} (${{ opt.price }})
                                    </div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-container
            v-show="acAddressComponents.street_number && acAddressComponents.street_number.length > 0"
          >
            <v-row>
              <v-col
                v-if="!isFormValid"
              >
                <v-alert
                  v-for="(err, idx) in formErrors"
                  :key="idx"
                  class="error"
                >
                  {{ err }}
                </v-alert>
              </v-col>
              <v-col
                cols="12"
              >
                <v-btn
                  class="px-8 my-n1"
                  color="success"
                  block
                  @click="doSubmitSignup"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template
        v-else
      >
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            style="max-width: 800px"
          >
            <v-card
              class="mx-3 my-3 px-5 py-3"
            >
              <div style="text-align: center">
                <p>You have successfully submitted the first part of your application!</p>
                <p>Your application code is: </p>
                <h4>
                  {{ this.signupRowkey }}
                </h4>
                </br>
                <p style="font-weight: bold; font-style: oblique">
                  A signed agreement is required before moving forward. Click below to sign if you have not already!
                </p>
                <template>
                  <v-btn
                    color="success"
                    @click="doOpenCognito"
                  >
                    Sign Agreement
                  </v-btn>
                </template>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            style="max-width: 800px"
          >
            <v-card
              class="mx-3 my-3 px-5 py-3"
            >
              <div style="text-align: center">
                <p>To submit another application please click 'Reset' blow.</p>

                <template>
                  <v-btn
                    color="error"
                    @click="doResetSingup"
                  >
                    RESET
                  </v-btn>
                </template>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <v-dialog
        v-model="successSubmittingSignup"
        persistent
        title="Success"
        color="Success"
      >
      </v-dialog>
    </div>
  </v-app>
</template>
<style>
  .lbl-header {
    font-size: 1.1em;
    color: #505050;
  }
  .lbl-option {
    font-size: .9em;
    color: #7a7a7a;
  }
</style>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  // import axios from 'axios'
  // import { LMap, LTileLayer, LMarker, LGeoJson, LLayerGroup, LControlLayers, LIcon, LTooltip, LWMSTileLayer } from 'vue2-leaflet'
  // import 'leaflet/dist/leaflet.css'
  //  var turf = require('@turf/turf')

  export default {
    name: 'SignUp',

    components: {
      VueGoogleAutocomplete,
    },

    data: () => ({
      acAddressComponents: [],
      acAddressCoords: { lat: 37.794603, lng: -120.99223 },
      displaySignupForm: false,
      locationServiceable: true,
      mapStyleMd: {
        display: 'inline-block',
        width: '100%',
        height: '400px',
      },
      activeTab: 0,
      drawer: null,
      isFormValid: false,
      successSubmittingSignup: false,
      formErrors: [],
      signupKey: '',
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      formValues: {
        serviceType: '',
        servicePlan: '',
        locationDesc: false,
        squareFootage: 0,
        roofMaterial: '',
        ownershipStatus: '',
        canModify: false,
        confirmMountEquipment: false,
        installType: '',
        accountHolder: {
          first_name: '',
          last_name: '',
          mobile_phone: '',
          mobile_phone_code: '',
          mobile_phone_verified: false,
          alt_phone: '',
          email: '',
          email_code: '',
          email_verified: false,
        },
        billingHolder: {
          first_name: '',
          last_name: '',
          mobile_phone: '',
          alt_phone: '',
          email: '',
        },
        locationService: {
          addr1: '',
          city: '',
          state: '',
          zip: '',
          lat: '',
          lng: '',
        },
        locationBilling: {
          addr1: '',
          city: '',
          state: '',
          zip: '',
        },
        paymentFrequency: 1,
        paymentMethod: '',
        enrollNoWorries: 0,
        enrollWifiUpgrade: false,
        addNetworkJacks: false,
        addNetworkJacksQuantity: 0,

      },
      optionsLocationTypes: [
        {
          text: 'Residential',
          value: 'residential',
        },
        {
          text: 'Commercial',
          value: 'commercial',
        },
        {
          text: 'Agriculture',
          value: 'agriculture',
        },
      ],
      optionsServicePlans: [
        {
          text: 'Standard 2.5 mbps',
          value: 'select',
          price: 49.95,
        },
        {
          text: 'Standard 10 mbps',
          value: 'video_streamer',
          price: 69.95,
        },
      ],
      optionsLocationDesc: [
        {
          text: 'Single Floor',
          value: 'single_floor',
        },
        {
          text: 'Multi floor',
          value: 'multi_floor',
        },
      ],
      optionsRoofMaterial: [
        {
          text: 'Tile',
          value: 'tile',
        },
        {
          text: 'Composition',
          value: 'composition',
        },
        {
          text: 'Other',
          value: 'other',
        },
      ],
      optionsSquareFootage: [
        {
          text: '1200 sq ft or less',
          value: 1200,
        },
        {
          text: '1500 sq ft',
          value: 1500,
        },
        {
          text: '1800 sq ft',
          value: 1800,
        },
        {
          text: '2000 sq ft',
          value: 2000,
        },
        {
          text: '2200 sq ft',
          value: 2200,
        },
        {
          text: '2400 sq ft',
          value: 2400,
        },
        {
          text: '2600+ sq ft',
          value: 2600,
        },
      ],
      optionsOwnershipStatus: [
        {
          text: 'Own',
          value: 'own',
        },
        {
          text: 'Rent or Lease',
          value: 'rent',
        },
      ],
      optionsInstallType: [
        {
          text: 'Standard',
          description: 'Exposed cable neatly routed through an exterior wall',
          value: 'standard',
          price: 45.00,
        },
        {
          text: 'Advanced',
          description: 'Cable ran to an interior wall from attic or crawl space',
          value: 'advanced',
          price: 145.00,
        },
      ],
      optionsPaymentFrequency: [
        {
          text: 'Monthly',
          description: '(No Discount)',
          value: 1,
        },
        {
          text: 'Prepay 6 Months',
          description: '(2.5% discount)',
          value: 6,
        },
        {
          text: 'Prepay 12 Months',
          description: '(5% discount)',
          value: 12,
        },
      ],
      optionsPaymentMethod: [
        {
          text: 'eCheck',
          description: 'Checking and routing number',
          value: 'echeck',
          price: 0,
        },
        {
          text: 'Bank bill pay',
          description: 'Setup bill pay via your bank',
          value: 'bankbillpay',
          price: 0,
        },
        {
          text: 'Credit Card',
          description: 'Visa/Mastercard only',
          value: 'creditcard',
          price: 0,
        },
      ],
      optionsEnrollNoWorries: [
        {
          text: 'Yes',
          value: 1,
        },
        {
          text: 'No',
          value: -1,
        },
      ],
      optionsNetworkJacks: [
        {
          text: '0',
          value: 0,
          price: 0,
        },
        {
          text: '1',
          value: 1,
          price: 100,
        },
        {
          text: '2',
          value: 2,
          price: 200,
        },
        {
          text: '3',
          value: 3,
          price: 300,
        },
      ],
      optionsHeardAboutUs: [
        {
          text: '0',
          value: 0,
          price: 0,
        },
        {
          text: '1',
          value: 1,
          price: 100,
        },
        {
          text: '2',
          value: 2,
          price: 200,
        },
        {
          text: '3',
          value: 3,
          price: 300,
        },
      ],
    }),
    watch: {
      acAddressComponents: function (val) {
        this.verifyDisplayFormStatus()
        this.locationServiceable = this.verifyLocationServiceable()
      },
      optionsServicePlans: function (val) {
        this.locationServiceable = this.verifyLocationServiceable()
      },
    },
    computed: {
      ...mapGetters(['signupRowkey', 'signupData']),
      apptCoords: function () {
        var latitude = typeof this.acAddressCoords.lat !== 'undefined' ? this.acAddressCoords.lat : 37.794603
        var longitude = typeof this.acAddressCoords.lng !== 'undefined' ? this.acAddressCoords.lng : -120.99223
        return { lat: latitude, lng: longitude }
      },
    },
    mounted () {
      window.addEventListener('load', () => {
        // console.log('everything is loaded, lets do this');
        // run after everything is in-place
        // eslint-disable-next-line no-prototype-builtins
        if (this.$route.query.hasOwnProperty('tab')) {
          var tabIndex = this.$route.query.tab
          if (tabIndex >= 0) {
            this.activeTab = parseInt(tabIndex, 10)
          }
        }
      })
    },
    async created () {
      // await this.doGetAccounts()
      console.log('page loaded')
      // console.log(this.accounts)
      console.log(this.$route)
      if (this.$route.params.key) {
        this.signupKey = this.$route.params.key
        const payload = {
          rowkey: this.$route.params.key,
        }
        this.selectedAccount = await this.getAccount(payload)
      }
    },
    methods: {
      ...mapActions(['submitSignup',
                     'getMobileVerificationCode',
                     'verifyMobile',
                     'getEmailVerificationCode',
                     'verifyEmail',
                     'resetSignup',
                     'getAvailablePlans']),
      async doSubmitSignup () {
        // if (this.formValues.accountHolder.mobile_phone === '' && this.formValues.accountHolder.email === '') {
        //
        // }
        this.formErrors = []
        let validForm = this.$refs.form.validate()
        if (!validForm) {
          this.formErrors.push('Please make sure to fill all required fields as indicated by red warnings')
        }
        if (!this.formValues.accountHolder.email_verified && !this.formValues.accountHolder.mobile_phone_verified) {
          validForm = false
          this.formErrors.push('We require at least one form of contact be verified before submitting your application')
        }
        // this.$router.push(cognitoUrl)
        if (validForm) {
          try {
            const results = await this.submitSignup(this.formValues)
            this.signupRowkey = results.rowkey
            this.successSubmittingSignup = true
            this.doOpenCognito()
          } catch (e) {
            console.log(e)
          }
        }
      },
      async doOpenCognito () {
        const cognitoPayload = {
          Name: {
            First: `${this.signupData.accountHolder.first_name}`,
            Last: `${this.signupData.accountHolder.last_name}`,
          },
          ServiceAddress: {
            City: `${this.signupData.locationService.city}`,
            Line1: `${this.signupData.locationService.addr1}`,
            PostalCode: `${this.signupData.locationService.zip}`,
          },
          Phone: `${this.signupData.accountHolder.mobile_phone}`,
          Email: `${this.signupData.accountHolder.email}`,
          PrintedName: `${this.signupData.accountHolder.first_name} ${this.signupData.accountHolder.last_name}`,
          ApplicationCode: this.signupRowkey,
        }
        // requestforinstall
        // const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/aupcsa?entry=${JSON.stringify(cognitoPayload)}`
        // const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/requestforinstall?entry=${JSON.stringify(cognitoPayload)}`
        const cognitoUrl = `https://www.cognitoforms.com/VelociterWireless/requestforinstallationpackage?entry=${JSON.stringify(cognitoPayload)}`
        console.log(cognitoUrl)
        window.location.href = cognitoUrl
      },
      async doResetSingup () {
        this.resetSignup()
      },
      async doRetrieveMobileCode () {
        const result = await this.getMobileVerificationCode(this.formValues.accountHolder.mobile_phone)
        if (result.code && result.code.length > 0) {
          alert(`A text has been sent to ${this.formValues.accountHolder.mobile_phone}`)
        } else {
          alert(`An error occured when sending a text to ${this.formValues.accountHolder.mobile_phone}`)
        }
      },
      async doRetrieveEmailCode () {
        const result = await this.getEmailVerificationCode(this.formValues.accountHolder.email)
        if (result.code && result.code.length > 0) {
          alert(`An email has been sent to ${this.formValues.accountHolder.email}`)
        } else {
          alert(`An error occured when sending an email to ${this.formValues.accountHolder.email}`)
        }
      },
      doCopyAccountHolder () {
        this.formValues.billingHolder = { ...this.formValues.accountHolder }
      },
      doCopyServiceAddress () {
        this.formValues.locationBilling = { ...this.formValues.locationService }
      },
      validate () {
        this.$refs.form.validate()
      },
      async onMobileCodeChange (event) {
        console.log(event)
        const payload = { contact: this.formValues.accountHolder.mobile_phone, code: event }
        const resp = await this.verifyMobile(payload)
        // eslint-disable-next-line camelcase
        const { code } = resp
        // eslint-disable-next-line camelcase
        this.formValues.accountHolder.mobile_phone_verified = code === event
        console.log(resp)
      },
      async onEmailCodeChange (event) {
        console.log(event)
        const payload = { contact: this.formValues.accountHolder.email, code: event }
        const resp = await this.verifyEmail(payload)
        // eslint-disable-next-line camelcase
        const { code } = resp
        // eslint-disable-next-line camelcase
        this.formValues.accountHolder.email_verified = code === event
        console.log(resp)
      },
      verifyDisplayFormStatus () {
        if (this.acAddressComponents.street_number && this.acAddressComponents.street_number.length > 0 && this.verifyLocationServiceable) {
          return true
        }
        return false
      },
      verifyLocationServiceable () {
        if (this.acAddressComponents.street_number && this.acAddressComponents.street_number.length > 0 && this.optionsServicePlans.length > 0) {
          return true
        }
        return false
      },
      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      async getAddressData (addressData, placeResultData, id) {
        this.acAddressCoords.lat = addressData.latitude
        this.acAddressCoords.lng = addressData.longitude
        this.optionsServicePlans = await this.getAvailablePlans(this.acAddressCoords)
        console.log('PlaceChanged in Autocomplete:', addressData)
        console.log('PlacesResultData in Autocomplete:', placeResultData)
        this.acAddressComponents = addressData

        this.formValues.locationService.addr1 = `${this.acAddressComponents.street_number} ${this.acAddressComponents.route}`
        this.formValues.locationService.city = this.acAddressComponents.locality
        this.formValues.locationService.state = this.acAddressComponents.administrative_area_level_1
        this.formValues.locationService.zip = `${this.acAddressComponents.postal_code}`
        this.formValues.locationService.lat = this.acAddressComponents.latitude
        this.formValues.locationService.lng = this.acAddressComponents.longitude
      },
    },
  }
</script>
